module.exports = __webpack_public_path__ + "static/media/accountDetails.de74a21e.svg";